import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const rootRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  
  if (authService.isAuthenticated()) {
    const role = authService.getAccessTokenRole();
    const dashboard = authService.getDashboard(role);
    
    const returnUrl = route.queryParamMap.get('returnUrl') || route.queryParamMap.get('redirect');
    const redirectTarget = returnUrl?.startsWith('/') ? returnUrl : dashboard;
    
    return router.createUrlTree([redirectTarget]);
  }

  return true;
};
